<template>
  <div>
    <div class="tab-names">
      <button v-for="(tab, index) in tabs" :key="tab.name" class="tab-button"
        :class="{ active: activeTabIndex === index }" @click="activateTab(index)">
        {{ tab.name }}
      </button>
    </div>

    <div class="tab-content">
      <slot :name="'tab' + (activeTabIndex + 1)"></slot>
    </div>

    <div class="tab-navigation">
      <div class="left-buttons">
        <AddButton @click="prev" :disabled="activeTabIndex === 0" btnname="Prev"></AddButton>
      </div>
      <div class="right-buttons">
        <AddButton @click="next" :disabled="activeTabIndex === tabs.length - 1" btnname="Next"></AddButton>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref, PropType, watch } from "vue";


// Define a type for the tab object
interface Tab {
  name: string;
}

export default defineComponent({
  name: "StepperTabs",
  props: {
    tabs: {
      type: Array as PropType<Tab[]>, // Explicitly define the type of 'tabs'
      required: true,
    },
    activeTabIndex1: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const activeTabIndex = ref(0);
    watch(
      () => props.activeTabIndex1,
      (newVal: any) => {
        next();
      }
    );

    function activateTab(index: number) {
      activeTabIndex.value = index;
    }

    function next() {
      // Access 'tabs' from 'props'
      if (activeTabIndex.value < props.tabs.length - 1) {
        activeTabIndex.value++;
      }
    }

    function prev() {
      // Access 'tabs' from 'props'
      if (activeTabIndex.value > 0) {
        activeTabIndex.value--;
      }
    }

    return {
      activeTabIndex,
      activateTab,
      next,
      prev,
    };
  },
});
</script>



<style scoped lang="scss">
.tab-names {
  position: relative;
  z-index: 1;
  background-color: white;
  padding-top: 10px;
  padding-bottom: 10px;
}

.tab-names.sticky {
  position: fixed;
  top: 0;
  width: 100%;
}

.tab-names .tab-button {
  margin-right: 1rem;
  background-color: transparent;
  border: none;
  cursor: pointer;
}

.tab-names .tab-button.active {
  font-weight: 500;
  color: #444444;
  background-color: #cbe4ff;
}

.tab-names .tab-separator {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.tab-names {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white !important;
  overflow: auto;
  padding: 10px 15px;
  border-top: 1px solid #e1e1e1;
  box-shadow: 0px 3px 3px #00000029;
}

.tab-navigation {
  position: fixed;
  left: 0;
  right: 0;
  bottom: -20px;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  background-color: white !important;
  z-index: 10;
}

.left-buttons {
  margin-left: 10px;
}

.right-buttons {
  margin-right: 10px;
}

.tab-button {
  font-size: 14px !important;
  border: 1px solid #999999 !important;
  padding: 5px 10px;
  border-radius: 10px;
  width: max-content;
  white-space: nowrap;
}

.tab-names button {
  margin-right: 1rem;
  background-color: transparent;
  border: none;
  cursor: pointer;
}

.tab-names button.active {
  font-weight: 500;
  color: #444444;
  background-color: #cbe4ff;
  border: 1px solid #0a82ff !important;
}

.tab-content>div {
  display: none;
}

.tab-content>div.active {
  display: block;
}

.tab-navigation {
  margin-bottom: 1rem;
}

.tab-navigation button {
  margin-right: 1rem;
}

@media only screen and (max-width: 887px) {
  .tab-names {
    justify-content: start;
  }
}
</style>
